<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">

    <span class="panel-title" *ngIf="!vacationTypeid">{{'app.create' | translate}}</span>
    <span class="panel-title" *ngIf="vacationTypeid">{{'app.editTile' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="container text-center" *ngIf="displayMode==1">
        <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
      </div>
      <form #f="ngForm" *ngIf="displayMode==2"
            novalidate (ngSubmit)="save(f)">
        <div class="row padding-sm-vr" *ngIf="!vacationTypeid">
          <div class="col-sm-8">
            <span>{{'app.enterDataOrUpload' | translate}}</span>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-2 cursor-pointer left-6">
            <span class="margin-right-7 edit-profile-span" (click)="showProvisionModal()">{{'app.provision' | translate}}</span>
            <i class="fa fa-upload" aria-hidden="true"></i>
          </div>
        </div>

        <div class="row padding-sm-vr">
          <div class="col-sm-6">
            <div [ngClass]="{'has-success': (name.dirty || name.touched || f.submitted)  && name.valid, 'has-error' : (name.dirty || name.touched || f.submitted)  && name.invalid}">
              <label class="control-label">{{'app.name' | translate}} </label>
              <input type="text"
                     name="name"
                     [(ngModel)]="vacationType.name"
                     #name="ngModel"
                     required="required"
                     class="form-control" maxlength="200"/>
              <div *ngIf="(name.dirty || name.touched || f.submitted)  && name.invalid" class="jquery-validate-error help-block">
                {{'app.RequiredField' | translate}}
              </div>
            </div>
          </div>
        </div>

        <div class="row padding-sm-vr" *ngIf="isVac">
          <div class="col-sm-2">
            <label class="control-label">{{'vacationCredit.creditToggle' | translate}}</label>
            <div>
              <label class="switch">
                <input type="checkbox" name="hasCredit" [(ngModel)]="vacationType.hasCredit" (ngModelChange)="onCreditToggle()">
                <span class="slider round"></span>
              </label>
            </div>
          </div>
          <div class="col-sm-3" *ngIf="vacationType.hasCredit">
            <div [class.has-error]="f.submitted && creditInvalid">
              <label class="control-label">{{'vacationCredit.defaultCredit' | translate}}</label>
              <input type="number" name="defaultCredit" [(ngModel)]="vacationType.defaultCredit" min="0" max="366" step="0.5" required class="form-control" />
              <small class="text-muted">{{'vacationCredit.defaultCreditHint' | translate}}</small>
              <div *ngIf="f.submitted && creditInvalid" class="jquery-validate-error help-block">{{'vacationCredit.creditRule' | translate}}</div>
            </div>
          </div>
          <div class="col-sm-3" *ngIf="vacationType.hasCredit">
            <label class="control-label">{{'vacationCredit.restrictedToggle' | translate}}</label>
            <div>
              <label class="switch">
                <input type="checkbox" name="isRestricted" [(ngModel)]="vacationType.isRestricted">
                <span class="slider round"></span>
              </label>
            </div>
            <small class="text-muted">{{(vacationType.isRestricted ? 'vacationCredit.restrictedOnHint' : 'vacationCredit.restrictedOffHint') | translate}}</small>
          </div>
          <div class="col-sm-4" *ngIf="vacationType.isCarriedOver">
            <span class="vt-carried"><i class="fa fa-info-circle"></i> {{'vacationCredit.carriedOver' | translate}}</span>
          </div>
        </div>

        <div class="panel-footer margin-left-20 margin-top-20 margin-left-37">
          <button class="btn  btn-cancel" type="button" (click)="back()">{{'app.cancel' | translate}}</button>&nbsp;
          <button class="btn  btn-save" type="submit">{{'app.save' | translate}}</button>

        </div>
      </form>
    </div>
  </div>

</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    <button type="button" class="close" data-dismiss="alert">×</button>
    {{'app.ServerError' |translate}}.
  </div>
</div>
